/**
 * Internal dependencies
 */
import vd from 'lib/vd';

export default (id) => (dispatch) => {
	return vd
		.importOperation(id)
		.startOperation()
		.then((operation) => {
			return operation;
		});
};
